import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { withLocalize, Translate } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { isEqual } from 'lodash';
import { searchActions, searchStatus, propertySkSearchBy } from '../../../store/searchStore';
import { domainActions, propertySkDomainKeys } from '../../../store/domainStore';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { MomentDate } from '../../common/momentComponent';
import { Circles } from "../../common/loadingComponent";
import { writeErr } from '../../common/logger';
import { getParams } from '../../common/utils';
import Message from '../../common/message';
import NoDataComponent from '../../common/noDataComponent';

import './propertySk.scss';

class PropertySkSearchResults extends React.Component {
    mounted = false;
    pageSize = 30;

    render() {
        if (this.props.search.status === searchStatus.idle)
            return <NoDataComponent />;

        if (this.props.search.status === searchStatus.requested)
            return <Circles />;

        if (this.props.search.status === searchStatus.error) {
            return (<div className="error-container error-container-wide" style={{ marginTop: "0.75em" }}>
                <Message type="warning" options={{ renderInnerHtml: true }} message={this.props.translate(this.props.search.error.message)} />
            </div>)
        }

        var data = this.getData();
        if (isNullOrUndefined(data))
            return <NoDataComponent />;

        const params = getParams(window.location.search);
        var searchParams = this.parseParamsToView(params);

        var agentLanguage = this.props.user.authentication.profile.agentLanguage;

        return (
            <>
                {this.renderReportDateInformation()}
                <div className='card'>
                    <div style={{ backgroundColor: '#fbfbfb', borderRadius: '10px 10px 0px 0px' }}>
                        <div style={{ padding: '10px 15px' }}>
                            <div><b><Translate id='Search.Parameters' /></b></div>
                            <div style={{ fontSize: '0.8em' }}>
                                {searchParams.map((s, i) => { return i + 1 === searchParams.length ? s : <>{s} | </> })}
                            </div>
                        </div>
                    </div>
                    <div className='card-body'>
                        {data.length > 0 && this.renderSearchResults(data)}
                        {data.length === 0 && <div><Translate id='Search.Cee.ResultCount' />: 0</div>}
                    </div>
                </div>
                <div className="disclaimer-wrapper">
                    <div className="report-component" style={{ textAlign: "center" }}><Translate id="Report.Footer" /></div>
                    <hr style={{ marginTop: "4px", marginBottom: "4px", height: "1px" }} />
                    <div className="disclaimer-gray">
                        <Translate id="PropertySk.Document.Disclaimer1" /> <Translate id={agentLanguage === 'sk-SK' ? "Report.DisclaimerSk" : "Report.DisclaimerCz"} options={{ renderInnerHtml: true }} />
                    </div>
                </div>
            </>
        )
    }

    componentDidMount() {
        this.mounted = true;
        if (!isNullOrUndefined(window.location.search) && window.location.search !== "") {
            const params = this.parseParams(getParams(window.location.search));
            if (!isNullOrUndefined(params))
                this.props.propertySkSearch(params);
        }

        this.props.ensureDomainData(propertySkDomainKeys.cadastreUnits);
    }

    componentDidUpdate() {
        if (!this.mounted)
            return;

        if (!isNullOrUndefined(window.location.search) && window.location.search !== "") {
            const params = this.parseParams(getParams(window.location.search));
            if (!isNullOrUndefined(params) && !isEqual(this.props.search.params, params))
                this.props.propertySkSearch(params);
        }

        if (this.mounted && !this.hasDomainData(propertySkDomainKeys.cadastreUnits))
            this.props.ensureDomainData(propertySkDomainKeys.cadastreUnits);
    }

    hasDomainData = (key) => !(isNullOrUndefined(this.props.domain[key]) ||
        (isNullOrUndefined(this.props.domain[key].requestResult) || this.props.domain[key].isRequesting));

    renderReportDateInformation() {
        return (
            <div className="property-sk-query-date">
                <div>
                    <span><Translate id="Report.Date" />:&nbsp;</span>
                    <span className="bold"><MomentDate value={new Date()} /></span>
                </div>
            </div>
        );
    }

    renderSearchResults = (data) => {
        switch (this.searchBy()) {
            case propertySkSearchBy.companyOwners:
            case propertySkSearchBy.personOwners:
                return this.renderOwnerSearchResult(data);
            case propertySkSearchBy.ownershipDeed:
            case propertySkSearchBy.registrationNumber:
            case propertySkSearchBy.landId:
            case propertySkSearchBy.flatNumber:
                return this.renderOwnershipDeedSearchResult(data);
            default:
                return <NoDataComponent />;
        }
    }

    renderOwnerSearchResult = (data) => {
        return (
            <>
                {data.map((s, idx) =>
                    <div key={s.rowNumber} className="property-sk-search-result">
                        <div className="property-sk-index">{s.rowNumber}.</div>
                        <div className="property-sk-data">
                            <div className="property-sk-identification">
                                <span className="property-sk-name">
                                    <span onClick={() => this.onSearchOwnerOdsClicked(s)}
                                    >{s.name}</span>
                                </span>{this.renderItemIdentification(s)}
                            </div>
                            <span>{s.address}</span>
                        </div>
                    </div>)}
            </>
        )
    }

    renderOwnershipDeedSearchResult = (data) => {
        return (
            <table className="table table-report-section table-stretched without-hover">
                <thead>
                    {this.renderOdSearchResultHeader()}
                </thead>
                <tbody>
                    {data.map((od, i) => this.renderOdSearchResultItem(od, i))}
                </tbody>
            </table>
        );
    }

    renderItemIdentification = (item) => {
        if (!isNullOrUndefined(item.birthDate)) {
            return (
                <span>
                    <> | </>
                    {item.birthDateFormated}
                    {isNullOrUndefined(item.birthDateCoowner) ? null : <>,&nbsp;{item.birthDateCoownerFormated}</>}
                </span>
            );
        }

        if (!isNullOrUndefined(item.companyId))
            return <span><> | </>{item.companyId}</span>

        return null;
    }

    renderOdSearchResultHeader = () => {
        switch (this.searchBy()) {
            case propertySkSearchBy.ownershipDeed:
                return (
                    <tr>
                        <th></th>
                        <th width="50%"><Translate id="PropertySk.Search.OwnershipDeedNo" /></th>
                        <th width="50%"><Translate id="PropertySk.Search.CadastreUnit" /></th>
                    </tr>
                );
            case propertySkSearchBy.registrationNumber:
                return (
                    <tr>
                        <th></th>
                        <th width="20%"><Translate id="PropertySk.Search.OwnershipDeedNo" /></th>
                        <th width="20%"><Translate id="PropertySk.Search.CadastreUnit" /></th>
                        <th width="20%"><Translate id="PropertySk.Search.RegistrationNumber" /></th>
                        <th width="20%"><Translate id="PropertySk.Search.BuildingType" /></th>
                        <th width="20%"><Translate id="PropertySk.Search.ParcelNumber" /></th>
                    </tr>
                );
            case propertySkSearchBy.landId:
                return (
                    <tr>
                        <th></th>
                        <th width="34%"><Translate id="PropertySk.Search.OwnershipDeedNo" /></th>
                        <th width="33%"><Translate id="PropertySk.Search.CadastreUnit" /></th>
                        <th width="33%"><Translate id="PropertySk.Search.ParcelNumber" /></th>
                    </tr>
                );
            case propertySkSearchBy.flatNumber:
                return (
                    <tr>
                        <th></th>
                        <th width="20%"><Translate id="PropertySk.Search.OwnershipDeedNo" /></th>
                        <th width="20%"><Translate id="PropertySk.Search.CadastreUnit" /></th>
                        <th width="20%"><Translate id="PropertySk.Search.RegistrationNumber" /></th>
                        <th width="20%"><Translate id="PropertySk.Search.FlatNumber" /></th>
                        <th width="20%"><Translate id="PropertySk.Search.SpaceType" /></th>
                    </tr>
                );
            default:
                return null;
        }
    }

    renderOdSearchResultItem = (item, idx) => {
        const params = {};
        const index = idx + this.props.search.params.offset + 1;

        switch (this.searchBy()) {
            case propertySkSearchBy.ownershipDeed:
            case propertySkSearchBy.landId:
                params.cadastreUnitId = this.props.search.params.cadastreUnitId;
                params.ownershipDeedNo = item.ownershipDocumentNumber
                return (
                    <tr key={item.rowNumber}>
                        <td>{index}.</td>
                        <td>
                            <Link className="link-internal property-sk-link" to={`ownership-deed${this.toQueryString(params)}`}>
                                {item.ownershipDocumentNumber}
                            </Link>
                        </td>
                        <td>{item.cadastreUnitName}</td>
                        {this.searchBy() === propertySkSearchBy.landId && <td>{item.landId}</td>}
                    </tr>
                );
            case propertySkSearchBy.registrationNumber:
                params.cadastreUnitId = this.props.search.params.cadastreUnitId;
                params.ownershipDeedNo = item.ownershipDocumentNumber;
                return (
                    <tr key={item.rowNumber}>
                        <td>{index}.</td>
                        <td>
                            <Link className="link-internal property-sk-link" to={`ownership-deed${this.toQueryString(params)}`}>
                                {item.ownershipDocumentNumber}
                            </Link>
                        </td>
                        <td>{item.cadastreUnitName}</td>
                        <td>{item.registrationNumber}</td>
                        <td>{item.buildingType}</td>
                        <td>{item.landId}</td>
                    </tr>
                );
            case propertySkSearchBy.flatNumber:
                params.cadastreUnitId = this.props.search.params.cadastreUnitId;
                params.ownershipDeedNo = item.ownershipDocumentNumber;
                params.hash = this.props.search.params.hash;
                params.companyId = this.props.search.params.entityId;
                return (
                    <tr key={item.rowNumber}>
                        <td>{index}.</td>
                        <td>
                            <Link className="link-internal property-sk-link" to={`ownership-deed${this.toQueryString(params)}`}>
                                {item.ownershipDocumentNumber}
                            </Link>
                        </td>
                        <td>{item.cadastreUnitName}</td>
                        <td>{this.props.search.params.registrationNumber}</td>
                        <td>{this.props.search.params.flatNumber}</td>
                        <td>{this.props.translate(`PropertySk.Search.${(this.props.search.params.isFlatArea ? "Flat" : "NonFlat")}`)}</td>
                    </tr>
                );
            default:
                return null;
        };
    }

    searchBy = () => isNullOrUndefined(this.props.search.params) ? null : this.props.search.params.searchBy;

    getData = () => {
        switch (this.searchBy()) {
            case propertySkSearchBy.companyOwners:
            case propertySkSearchBy.personOwners:
                return isNullOrUndefined(this.props.search) ? null : isNullOrUndefined(this.props.search.data) ? null : this.props.search.data.owners
            case propertySkSearchBy.ownershipDeed:
            case propertySkSearchBy.registrationNumber:
            case propertySkSearchBy.landId:
            case propertySkSearchBy.flatNumber:
                return isNullOrUndefined(this.props.search) ? null : isNullOrUndefined(this.props.search.data) ? null : this.props.search.data.ownershipDocuments;
            default:
                return null;
        };
    }

    parseParams = (params) => {
        try {
            const paging = {
                count: isNullOrUndefined(params.count) ? this.pageSize : parseInt(params.count),
                offset: isNullOrUndefined(params.offset) ? 0 : parseInt(params.offset)
            }

            switch (parseInt(params.searchBy)) {
                case propertySkSearchBy.companyOwners:
                    return {
                        searchBy: propertySkSearchBy.companyOwners,
                        owner: params.owner,
                        companyId: params.companyId,
                        ...paging
                    };
                case propertySkSearchBy.personOwners:
                    {
                        var result = {
                            searchBy: propertySkSearchBy.personOwners,
                            name: params.name,
                            surname: params.surname,
                            ...paging
                        }
                        if (params.birthDate)
                            result.birthDate = params.birthDate;
                        return result;
                    }
                case propertySkSearchBy.ownershipDeed:
                    return {
                        searchBy: propertySkSearchBy.ownershipDeed,
                        cadastreUnitId: this.getInt(params.cadastreUnitId),
                        ownershipDeedNumber: this.getInt(params.ownershipDeedNo),
                        ...paging
                    };
                case propertySkSearchBy.registrationNumber:
                    return {
                        searchBy: propertySkSearchBy.registrationNumber,
                        cadastreUnitId: this.getInt(params.cadastreUnitId),
                        registrationNumber: this.getInt(params.registrationNumber),
                        ...paging
                    };
                case propertySkSearchBy.landId:
                    return {
                        searchBy: propertySkSearchBy.landId,
                        cadastreUnitId: this.getInt(params.cadastreUnitId),
                        parcelRegistry: params.register === "C" || params.register === "E" ? params.register : null,
                        landIdPart1: params.parcelNo1,
                        landIdPart2: params.parcelNo2,
                        landIdPart3: params.parcelNo3,
                        ...paging
                    };
                case propertySkSearchBy.flatNumber:
                    return {
                        searchBy: propertySkSearchBy.flatNumber,
                        cadastreUnitId: this.getInt(params.cadastreUnitId),
                        registrationNumber: this.getInt(params.registrationNumber),
                        flatNumber: this.getInt(params.flatNumber),
                        isFlatArea: isNullOrUndefined(params.spaceType) || this.getInt(params.spaceType) === 0,
                        ...paging
                    };
                default:
                    return null;
            };
        } catch {
            writeErr("Failed to parse input parameters");
            return null;
        }
    }

    parseParamsToView = (params) => {
        var searchParams = [];

        switch (parseInt(params.searchBy)) {
            case propertySkSearchBy.companyOwners:
                if (params.owner)
                    searchParams.push(<><Translate id='PropertySk.Search.Owner' />: <b>{params.owner}</b></>);
                if (params.companyId)
                    searchParams.push(<><Translate id='PropertySk.Search.CompanyId' />: <b>{params.companyId}</b></>);
                break;
            case propertySkSearchBy.personOwners:
                if (params.name)
                    searchParams.push(<><Translate id='PropertySk.Search.Name' />: <b>{params.name}</b></>);
                if (params.surname)
                    searchParams.push(<><Translate id='PropertyCz.Search.Surname' />: <b>{params.surname}</b></>);
                if (params.birthDate)
                    searchParams.push(<><Translate id='PropertySk.Search.BirthDate' />: <b><MomentDate value={params.birthDate} /></b></>);
                break;
            case propertySkSearchBy.ownershipDeed:
                if (params.cadastreUnitId)
                    searchParams.push(<><Translate id='PropertySk.Search.CadastreUnit' />: <b>{this.getCadastreUnitLabel(params.cadastreUnitId)}</b></>);
                if (params.ownershipDeedNo)
                    searchParams.push(<><Translate id='PropertySk.Search.OwnershipDeedNo' />: <b>{this.getInt(params.ownershipDeedNo)}</b></>);
                break;
            case propertySkSearchBy.registrationNumber:
                if (params.cadastreUnitId)
                    searchParams.push(<><Translate id='PropertySk.Search.CadastreUnit' />: <b>{this.getCadastreUnitLabel(params.cadastreUnitId)}</b></>);
                if (params.registrationNumber)
                    searchParams.push(<><Translate id='PropertySk.Search.RegistrationNumber' />: <b>{this.getInt(params.registrationNumber)}</b></>);
                break;
            case propertySkSearchBy.landId:
                if (params.cadastreUnitId)
                    searchParams.push(<><Translate id='PropertySk.Search.CadastreUnit' />: <b>{this.getCadastreUnitLabel(params.cadastreUnitId)}</b></>);
                if (params.register === "C" || params.register === "E")
                    searchParams.push(<><Translate id='PropertySk.Search.Register' />: <b>{params.register}</b></>);
                if (params.parcelNo1 || params.parcelNo2 || params.parcelNo3)    
                    searchParams.push(<><Translate id='PropertySk.Search.ParcelNumber' />: <b>{[params.parcelNo1, params.parcelNo2, params.parcelNo3].filter(x => !isNullOrUndefined(x) && x !== "").join(" / ")}</b></>);
                break;
            case propertySkSearchBy.flatNumber:
                if (params.cadastreUnitId)
                    searchParams.push(<><Translate id='PropertySk.Search.CadastreUnit' />: <b>{this.getCadastreUnitLabel(params.cadastreUnitId)}</b></>);
                if (params.registrationNumber)
                    searchParams.push(<><Translate id='PropertySk.Search.RegistrationNumber' />: <b>{this.getInt(params.registrationNumber)}</b></>);
                if (params.spaceType)
                    searchParams.push(<><Translate id='PropertySk.Search.SpaceType' />: <b>
                        {this.getInt(params.spaceType) === 0 ? this.props.translate("PropertySk.Search.Flat") : this.props.translate("PropertySk.Search.NonFlat")}
                    </b></>);
                if (params.flatNumber)
                    searchParams.push(<><Translate id='PropertySk.Search.FlatNumber' />: <b>{this.getInt(params.flatNumber)}</b></>);
                break;
            default:
                break;
        };
        return searchParams;
    }

    getCadastreUnitLabel = (cadastreUnitId) => {
        if (!this.hasDomainData(propertySkDomainKeys.cadastreUnits))
            return "";

        const cadastreUnit = this.props.domain[propertySkDomainKeys.cadastreUnits].requestResult.find(f => f.value === cadastreUnitId);
        return isNullOrUndefined(cadastreUnit) ? "" : cadastreUnit.label;
    }

    onSearchOwnerOdsClicked = (owner) => {
        this.setState({ params: null });
        if (!isNullOrUndefined(owner.entityId) && owner.entityId !== 0)
            this.props.history.push(`/search/property-sk/report?searchBy=${propertySkSearchBy.companyOwnerDeeds}&entityId=${encodeURIComponent(owner.entityId)}`);
        else if (!isNullOrUndefined(owner.hash))
            this.props.history.push(`/search/property-sk/report?searchBy=${propertySkSearchBy.personOwnerDeeds}&hash=${encodeURIComponent(owner.hash)}`);
    }

    getInt = (value) => {
        const tmp = isNullOrUndefined(value) ? null : parseInt(value);
        return isNullOrUndefined(tmp) || isNaN(tmp) ? null : tmp;
    }

    toQueryString = (dict) => {
        const list = Object.keys(dict).filter(f => !isNullOrUndefined(dict[f])).map(k => `${k}=${encodeURIComponent(dict[k])}`);
        return list.length === 0 ? "" : "?" + list.join("&");
    }
}

export default withRouter(withLocalize(connect(
    state => ({ search: { ...state.search.propertySk }, domain: state.domain, layout: state.layout, user: state.userContext }),
    dispatch => bindActionCreators(({ ...searchActions, ...domainActions }), dispatch)
)(PropertySkSearchResults)));
